import { render, staticRenderFns } from "./DeleteLoadlist.vue?vue&type=template&id=56756130&scoped=true"
import script from "./DeleteLoadlist.vue?vue&type=script&lang=ts"
export * from "./DeleteLoadlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56756130",
  null
  
)

export default component.exports